LIST   = '[data-behaviour=add-element-list]'
ITEM   = '[data-behaviour=add-element-item]'
INDEX  = '[data-behaviour=add-element-index]'
REMOVE = '[data-behaviour=add-element-remove]'
ADD    = '[data-behaviour=add-element-add]'

mask = /\[\d*\]/

updateElementEvent = document.createEvent('Event')
updateElementEvent.initEvent('updateElement', true, true)

addOrReplaceIndex = (id, mask, suffix) ->
  if id.match(mask) then id.replace(mask, suffix) else id + suffix

updateAttribute = (node, attr, suffix) ->
  name = attr.name
  value = attr.value
  if ['id', 'for'].includes(name)
    $(node).attr name, addOrReplaceIndex(value, mask, suffix)
  else
    $(node).attr name, value.replace(mask, suffix)

updateItem = (item, index) ->
  $item = $(item)
  $indexElement = $item.find(INDEX)
  $indexElement?.html($indexElement.data('mask').replace(mask, index + 1))
  $nodes = $item.find('*')
  suffix = "[#{index}]"

  $nodes.each (_, node) ->
    updateAttribute node, attr, suffix for attr in node.attributes

  $item.find(REMOVE).parent().css({ display: 'block' }) if index > 0
  $item.find('*').each (_, el) -> el.dispatchEvent(updateElementEvent)

setupItems = ->
  $list = $(LIST)
  if $list.find(INDEX).length
    $items = $list.children()
    $items.each (index, item) ->
      updateItem item, index
    $("[data-name=#{$list.data('name')}]#{ADD}").css('display', 'block') if $items.length < $list.data('max-items')

$ ->
  $(document).on 'click', ADD, (event) ->
    event.preventDefault()
    $this = $(this)
    name  = $this.data('name')
    $item = $($("[data-name=#{name}]#{ITEM}").html())

    $list = $("[data-name=#{name}]#{LIST}")
    $item.find('input, select, textarea').prop('disabled', false)

    $existingSelects = $item.find('select')
    $existingSelects.on 'contentChanged', ->
      $select = $ this
      $select.parent('.select-wrapper').replaceWith $select
      $select.selectpicker('refresh')

    $existingDatePickers = $item.find('.datepicker')
    $existingDatePickers.each ->
      window.CamBackend.activateDatePicker $(this)

    $list.append $item
    updateItem($item, $list.children().length - 1) if $item.find(INDEX).length

    $existingSelects.trigger 'contentChanged'
    $("[data-name=#{name}]#{ADD}").css('display', 'none') if $list.children().length >= $list.data('max-items')

  $(document).on 'click', REMOVE, (event) ->
    event.preventDefault()
    $(this).closest('.element--add').remove() # FIXME: class selector for now...
    setupItems()

$(document).ready(setupItems)
